<template>
  <transition-fade :duration="500" appear>
    <div
      v-if="routedVideo?.videoFile?._rendered"
      id="video-player"
      class="flex flex-col items-start h-full justify-stretch"
    >
      <h1 class="title-block grow-0 ml-[87px]">{{ routedVideo.title }}</h1>
      <div
        class="grid items-stretch justify-items-stretch self-stretch grow"
        v-html="routedVideo.videoFile._rendered"
      />
    </div>
  </transition-fade>
</template>

<script>
import { mapGetters } from "vuex";

import TransitionFade from "../../../components/magic/TransitionFade.vue";

export default {
  name: "VideoPlayer",
  components: {
    TransitionFade,
  },
  computed: {
    ...mapGetters(["routedVideo"]),
  },
};
</script>
